import ApiService from '../common/api.service'
import JwtService from '../common/jwt.service'
import {
  LOGIN,
  LOGOUT,
  VERIFYOTP
} from './actions.type'
import { SET_AUTH, PURGE_AUTH, SET_ERROR, AUTH_SUCESS } from './mutations.type'

// Helper function to handle API errors consistently
const handleApiError = (context, response) => {
  console.log(response)
  if (response.status === 401) {
    const errorMessage = response.data.detail
    if (errorMessage === 'Token has expired' || errorMessage === 'Invalid token.') {
      context.commit(SET_ERROR, response)
      localStorage.removeItem('ID_TOKEN_KEY')
      window.location.href = '/login'
      return Promise.reject(response)
    }
  }
  context.commit(SET_ERROR, response)
  return Promise.reject(response)
}

const state = {
  errors: null,
  user: {},
  isAuthenticated: !!JwtService.getToken(),
  authSucess: true,
  errorMessage: null,
  errorType: null
}

const getters = {
  currentUser () {
    return JSON.parse(window.localStorage.getItem('auth')).user_data
  },
  isAuthenticated (state) {
    return state.isAuthenticated
  },
  error (state) {
    return state.error
  },
  authSucess (state) {
    return state.authSucess
  },
  errorMessage (state) {
    return state.errorMessage
  },
  errorType (state) {
    return state.errorType
  }
}

const actions = {
  [LOGIN] (context, credentials) {
    return ApiService.post('login/', credentials)
      .then(({ data }) => {
        if (data.user_data) {
          context.commit(SET_AUTH, data)
          context.commit(AUTH_SUCESS)
        }
        return data
      })
      .catch(({ response }) => handleApiError(context, response))
  },
  [LOGOUT] (context) {
    return ApiService.post('logout/').catch(({ response }) => handleApiError(context, response)).finally(() => {
      context.commit(PURGE_AUTH)
    })
  },
  [VERIFYOTP] (context, credentials) {
    return ApiService.post('authenticate-otp/', credentials).then(({ data }) => {
      context.commit(SET_AUTH, data)
      context.commit(AUTH_SUCESS)
    }).catch(({ response }) => handleApiError(context, response))
  }
}

const mutations = {
  [SET_ERROR] (state, error) {
    state.errors = error.request.responseText
    state.errorMessage = error.request.responseText
    state.errorType = error.status + ': ' + error.statusText
  },
  [SET_AUTH] (state, user) {
    console.log(user)
    window.localStorage.setItem('auth', JSON.stringify(user))
    let userPermissions = []
    let userGroups = []
    if (user.user_data.groups.length > 0) {
      for (let j = 0; j < user.user_data.groups.length; j++) {
        userGroups.push(user.user_data.groups[j].name)
        for (let k = 0; k < user.user_data.groups[j].permissions.length; k++) {
          let codename = user.user_data.groups[j].permissions[k]['codename']
          if (!userPermissions.includes(codename)) {
            userPermissions.push(codename)
          }
        }
      }
    }
    // console.log(userPermissions)
    window.localStorage.setItem('userPermissions', JSON.stringify(userPermissions))
    window.localStorage.setItem('userGroups', JSON.stringify(userGroups))
    state.isAuthenticated = true
    state.user.id = user.user
    state.user.token = user.key
    state.errors = null
    state.authSucess = true
    JwtService.saveToken(state.user.token)
  },
  [AUTH_SUCESS] (state) {
    state.authSucess = false
  },
  [PURGE_AUTH] (state) {
    state.isAuthenticated = false
    state.user = {}
    state.errors = null
    JwtService.destroyToken()
    window.localStorage.clear()
  }
}

export default {
  state,
  actions,
  mutations,
  getters
}
